<template>
  <div v-editable="blok" class="accordion-container">
    <div class="acordion-border-box">
      <div class="flex items-center space-x-3 accordion px-4 pt-4">
        <input v-if="blok.checkbox" class="inline-block" type="checkbox" />
        <button
          class="flex items-center space-x-3"
          :aria-expanded="isOpen"
          :aria-controls="`collapse`"
          @click="toggleAccordion()"
        >
          <svg
            class="w-3 transition-all duration-200 transform"
            :class="{
              'rotate-180': isOpen,
              'rotate-0': !isOpen,
            }"
            fill="none"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 10"
            aria-hidden="true"
          >
            <path
              d="M15 1.2l-7 7-7-7"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p :class="{ opentitle: isOpen }" class="text-md font-bold text-left">
            {{ blok.title }}
          </p>
        </button>
      </div>

      <div v-show="isOpen" :id="`collapse`" class="accordion-content pt-4">
        <div class="p-4 rounded-tl-lg rounded-br-lg bg-sk-neutral4">
          <RichTextEditor :blok="{ text: blok.hiddenText }" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { AccordionBlokProps } from '@/types/Accordion';

const props = defineProps<{
  blok: AccordionBlokProps;
}>();

const isOpen = ref(props.blok.isOpen);

const toggleAccordion = () => {
  isOpen.value = !isOpen.value;
};
</script>
<style lang="scss">
.accordion-container {
  padding-bottom: 0.5rem;
}

.opentitle {
  color: #0abc28;
}

.accordion-content {
  color: #1d2227 !important;
}

.acordion-border-box {
  border-bottom: 1px solid #cdcdcd;
  padding-bottom: 1.5rem;
}
</style>
